import { useAuthContext } from "ui/context/auth";

export const useHasPermission = (permission: string) => {
  const { user } = useAuthContext();

  if (!user || !user.authorities) {
    return false;
  }
  return user.authorities.includes(permission);
};
